import { createSlice } from "@reduxjs/toolkit";
import { fetchTopMetrics } from "./thunk";

interface TopMetricsState {
  data: {
    totalSalesOrders: {
      value: number;
      growth: number;
      label: string;
    };
    totalQuotations: {
      value: number;
      growth: number;
      label: string;
    };
    totalEnquiries: {
      value: number;
      growth: number;
      label: string;
    };
    totalDispatch: {
      value: number;
      growth: number;
      label: string;
    };
  } | null;
  loading: boolean;
  error: string | null;
}

const initialState: TopMetricsState = {
  data: null,
  loading: false,
  error: null,
};

const topMetricsSlice = createSlice({
  name: "topMetrics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTopMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTopMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch top metrics data";
        // Set default values on error
        state.data = {
          totalSalesOrders: {
            value: 0,
            growth: 0,
            label: "Total Sales Orders",
          },
          totalQuotations: {
            value: 0,
            growth: 0,
            label: "Total Quotations",
          },
          totalEnquiries: {
            value: 0,
            growth: 0,
            label: "Total Enquiries",
          },
          totalDispatch: {
            value: 0,
            growth: 0,
            label: "Total Dispatch (Completed)",
          },
        };
      });
  },
});

export default topMetricsSlice.reducer;

